"use client";
import { Box, Skeleton } from "@mui/material";
import dynamic from "next/dynamic";

const PdpMobileHeader = dynamic(() => import("./PdpMobileHeader"), {
    ssr: false,
    loading: () => <Box sx={{ p: 1, height: 56, display: 'flex', justifyContent: 'space-between' }}>
        <Skeleton variant="circular" width={42} height={42} />
        <Skeleton variant="rounded" width={141} height={42} sx={{
            borderRadius: '48px'
        }} />
    </Box>,
});

export default PdpMobileHeader;
